
import React from 'react';
import Layout from '@/components/Layout/Layout';
import SitemapCategoryTable from '@/components/Sitemap/SitemapCategoryTable';
import { sitemapData } from '@/data/sitemapData';
import { calculatorCategories } from '@/data/calculatorCategories';

const SitemapPage = () => {
  // Calculate total calculators and available calculators
  const totalCalculators = sitemapData.reduce((acc, category) => acc + category.items.length, 0);
  const availableCalculators = sitemapData.reduce((acc, category) => 
    acc + category.items.filter(item => item.available).length, 0);
  
  return (
    <Layout>
      <div className="container mx-auto py-8">
        <h1 className="text-3xl font-bold mb-8">Site Map</h1>
        <p className="mb-4 text-gray-600">
          Complete list of all calculators and unit converters available on AllUnitCalculator.com
        </p>
        
        <div className="bg-blue-50 p-4 rounded-lg mb-8">
          <p className="text-blue-800 font-medium">
            Total Tools: {totalCalculators} | Available Now: {availableCalculators} | 
            Coming Soon: {totalCalculators - availableCalculators}
          </p>
        </div>

        <div className="grid gap-10">
          {sitemapData.map((category, index) => (
            <SitemapCategoryTable 
              key={index}
              title={category.title}
              items={category.items}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default SitemapPage;
